import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import "./orgStyle.css";
import { toast } from 'react-toastify';
import { api } from "../../app/Api/ApiSlice";

const CreateOrg = () => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState("business");
    const [tagline, setTagline] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [street, setStreet] = useState("");
    const [building, setBuilding] = useState("");
    const [room, setRoom] = useState("");
    const [email, setEmail] = useState("");
    const [postalCode, setPostalCode] = useState(""); // Changed initial state to empty string
    const [website, setWebsite] = useState("");
    const [phone, setPhone] = useState("");
    const [phone2, setPhone2] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsLoading(true); // Start loading immediately

        const formData = new FormData();
        formData.append("name", name);
        formData.append("description", description);
        formData.append("category", category);
        formData.append("tagline", tagline);
        formData.append("country", country);
        formData.append("state", state);
        formData.append("city", city);
        formData.append("street", street);
        formData.append("building", building);
        formData.append("room", room);
        formData.append("email", email);
        formData.append("postalCode", postalCode);
        formData.append("website", website);
        formData.append("phone", phone);
        formData.append("phone2", phone2);

        try {
            const response = await api.post("/organizations", formData);
            toast.success("Organization created successfully!");
            navigate(`/${response.data.name}`, { state: { org: response.data } });
        } catch (error) {
            console.error("Error creating organization:", error); // Use console.error for errors
            toast.error(error.response?.data?.message || "An error occurred. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className=''>
            <div className='form-wrapper create-form'>
                <h2 className="form-title">Create a new Organization</h2>
                <form className="org-form" onSubmit={handleSubmit}>
                    <div className="form-section">
                        <div className="form-details-wrapper">
                            <div className="form-input">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    name='name'
                                    placeholder='Enter the organization Name'
                                    value={name}
                                    required
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="form-input">
                                <label htmlFor="tagline">Tagline</label>
                                <input
                                    type="text"
                                    name='tagline'
                                    placeholder='Organization Tagline'
                                    value={tagline}
                                    onChange={(e) => setTagline(e.target.value)}
                                />
                            </div>
                            <div className="form-input">
                                <label htmlFor="description">Description</label>
                                <input
                                    type="text"
                                    name='description'
                                    placeholder='Describe your organization'
                                    value={description}
                                    required
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <label htmlFor="category">Category</label>
                            <select
                                name="category"
                                id="category"
                                required
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                            >
                                <option value="business">Business</option>
                                <option value="government">Government</option>
                                <option value="religious">Religious</option>
                                <option value="non-profit">Non-profit</option>
                                <option value="political party">Political party</option>
                                <option value="Education">Education</option>
                                <option value="Healthcare">Healthcare</option>
                                <option value="family">Family</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-section">
                        <h3 className='form-sub-header'>Address</h3>
                        <div className="form-address-wrapper">
                            <div className="form-address">
                                <div className="form-input">
                                    <label htmlFor="country">Country</label>
                                    <input
                                        type="text"
                                        name='country'
                                        value={country}
                                        required
                                        onChange={(e) => setCountry(e.target.value)}
                                    />
                                </div>
                                <div className="form-input">
                                    <label htmlFor="state">State</label>
                                    <input
                                        type="text"
                                        name='state'
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="form-contacts-wrapper"> {/* This wrapper name seems inconsistent with content */}
                                <div className="form-address">
                                    <div className="form-input">
                                        <label htmlFor="city">City</label>
                                        <input
                                            type="text"
                                            name='city'
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-input">
                                        <label htmlFor="street">Street</label>
                                        <input
                                            type="text"
                                            name='street'
                                            value={street}
                                            onChange={(e) => setStreet(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="form-address">
                                    <div className="form-input">
                                        <label htmlFor="building">Building</label>
                                        <input
                                            type="text"
                                            name='building'
                                            value={building}
                                            onChange={(e) => setBuilding(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-input">
                                        <label htmlFor="room">Room</label>
                                        <input
                                            type="text"
                                            name='room'
                                            value={room}
                                            onChange={(e) => setRoom(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="form-input"> {/* Added postal code input */}
                                    <label htmlFor="postalCode">Postal Code</label>
                                    <input
                                        type="text"
                                        name='postalCode'
                                        value={postalCode}
                                        onChange={(e) => setPostalCode(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-section form-contacts">
                        <h3 className="form-sub-header">Contacts</h3>
                        <div className="form-contacts-wrapper">
                            <div className="form-contacts">
                                <div className="form-input">
                                    <label htmlFor="email">Email</label>
                                    <input
                                        type="email"
                                        name='email'
                                        value={email}
                                        required
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="form-input">
                                    <label htmlFor="website">Website</label>
                                    <input
                                        type="url"
                                        name='website'
                                        value={website}
                                        onChange={(e) => setWebsite(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="form-contacts">
                                <div className="form-input">
                                    <label htmlFor="phone">Phone</label>
                                    <input
                                        type="tel"
                                        name='phone'
                                        placeholder='Phone'
                                        value={phone}
                                        required
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                                <div className="form-input">
                                    <label htmlFor="phone2">Phone 2</label>
                                    <input
                                        type="tel"
                                        name='phone2'
                                        placeholder='Phone 2'
                                        value={phone2}
                                        onChange={(e) => setPhone2(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-btn-wrapper">
                            <button className='create-form-btn' type="submit" disabled={isLoading}>
                                {isLoading ? "Loading..." : "Save"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateOrg;